import React, { ReactNode } from 'react';
import styles from '@base/features/user/styles/infoItem.module.scss';
import { t } from '@base/utils/helpers';

export default function InfoItem(props: {
  title: string;
  children?: string | number | ReactNode;
}) {
  return (
    <div className={styles.infoItem}>
      <h1>{t(props.title)}</h1>
      <div>{props.children}</div>
    </div>
  );
}
